
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'

import { useAuth } from '@/context/AuthContext'
import { useSignIn } from '@/hooks/useLeasing'
import { Loading } from '../components/Loading'
import { ErrorPage } from './ErrorPage'
import { useGetInsuranceParams } from '@/hooks/useWizard'

function LeasingLogin() {
  const navigate = useNavigate()
  const { token } = useParams()

  const { isLoading: isAuthLoading, user, reload } = useAuth()
  const { data: paramsId, mutateAsync, isPending } = useSignIn()

  useEffect(() => {
    if (token)
      mutateAsync({ token })
  }, [token])

  useEffect(() => {
    if (paramsId && !isAuthLoading) {
      reload()
    }
  }, [paramsId, isAuthLoading])

  useEffect(() => {
    if (user?.logged && paramsId) {
      switch (user.clientKey) {
        case 'VWFS':
          navigate('/vwfs/wizard/' + paramsId)
          break

        case 'BMWFS':
        case 'BMWFSSK':
        default:
          navigate('/wizard/' + paramsId)
          break
      }
    }
  }, [user, paramsId])

  if (!isPending && !paramsId)
    return <ErrorPage error='Chyba autorizace' />

  return (
    <Loading large={true} />
  )
}

export default LeasingLogin